import { getCandidateOfferingData } from "@Services/officer/recruitment";
import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import OnProgress from "./OnProgress";
import Zero from "./Zero";
import Styles from "./style.module.scss";
import ModalWrapper from "@Atom/ModalWrapper";
import FraudAlertModal from "@Molecule/_modal/FraudAlertModal";
import moment from "moment";
import SendingModal from "@Molecule/_modal/SendingModal";
import { sendFraudReport } from "@Services/officer/fraudReport";

export default function CandidateFormComponent({
  currentStep,
  setCurrentStep,
  syncData,
  // offeringData,
  // type,
}) {
  const [data, setData] = useState({});
  const [type, setType] = useState({});
  const { hash } = useParams();

  const [trigger, setTrigger] = useState(null);
  const [isPhoneVerified, setIsPhoneVerified] = useState(false);

  const refetch = useCallback(async () => {
    const data = await getCandidateOfferingData(hash);
    setData(data?.response);
    setType(data?.jobPostType);
  }, [hash]);

  useEffect(() => {
    refetch();
  }, [trigger, refetch]);

  const [fraudAlertModal, setFraudAlertModal] = useState(true);
  const [scamWarningSession, setScamWarningSession] = useState(false);
  const [files, setfiles] = useState(null);
  const [desc, setDesc] = useState("");
  const [success, setSuccess] = useState(false);

  const handleBackFraud = () => {
    setFraudAlertModal();
    if (scamWarningSession) {
      const today = moment().format("YYYY-MM-DD");
      localStorage?.setItem(`fraudAlertModal_offering_${hash}`, today);
    }
  };

  const [loadingFraud, setLoadingFraud] = useState(false);
  const [error, setError] = useState("");

  const handleSubmitFraud = async (e) => {
    try {
      e.preventDefault();
      setLoadingFraud(true);
      const formData = new FormData();

      formData.append("candidateID", data?.id);
      formData.append("remark", desc || "");
      formData.append("file", files || "");

      await sendFraudReport(formData);

      setLoadingFraud(false);
      setFraudAlertModal(false);
      if (scamWarningSession) {
        const today = moment().format("YYYY-MM-DD");
        localStorage?.setItem(`fraudAlertModal_offering_${hash}`, today);
      }
      setSuccess(true);
      setError("");
    } catch (err) {
      setSuccess(false);
      console.log(err);
      setLoadingFraud(false);
      setError(err?.response?.data?.error || err?.response?.data?.message);
    }
  };

  useEffect(() => {
    const savedDate = localStorage.getItem(`fraudAlertModal_offering_${hash}`);
    const today = moment().format("YYYY-MM-DD"); // Format tanggal hari ini
    if (savedDate === today) {
      setFraudAlertModal(false); // Jangan tampilkan modal jika tanggal tersimpan adalah hari ini
    }
  }, [hash]);

  return (
    <div className={Styles.container}>
      {currentStep === 0 ? (
        <Zero
          setCurrentStep={setCurrentStep}
          disableClick={data?.status !== "OFFER-INVITE" ? true : false}
          offeringData={data}
          refetch={refetch}
          type={type}
          isPhoneVerified={isPhoneVerified}
          setIsPhoneVerified={setIsPhoneVerified}
        />
      ) : (
        <OnProgress
          currentStep={currentStep}
          setCurrentStep={setCurrentStep}
          syncData={syncData}
          offeringData={data}
          setTriggerDefault={setTrigger}
          type={type}
          isPhoneVerified={isPhoneVerified}
          setIsPhoneVerified={setIsPhoneVerified}
          hash={hash}
        />
      )}

      {fraudAlertModal && (
        <ModalWrapper show={fraudAlertModal} handleClose={() => {}}>
          <FraudAlertModal
            isChecked={scamWarningSession}
            setIsChecked={setScamWarningSession}
            handleBack={handleBackFraud}
            files={files}
            setfiles={setfiles}
            desc={desc}
            setDesc={setDesc}
            handleClose={() => {
              setFraudAlertModal(false);
            }}
            handleSubmit={handleSubmitFraud}
            error={error}
            loadingFraud={loadingFraud}
          />
        </ModalWrapper>
      )}

      {success && (
        <SendingModal
          handleDone={() => {
            setSuccess(false);
          }}
          isDone={success}
          show={success}
          setShow={setSuccess}
        />
      )}
    </div>
  );
}
